<template>
  <div class="geolocation-wrapper">
    <div class="geolocation-input"></div>
  </div>
</template>
<script>
import places from "places.js";
export default {
  props: {
    apiKey: {
      type: String,
      required: false,
    },
    appId: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    prefilled: {
      required: false,
    },
  },
  data() {
    return { instance: null };
  },
  mounted() {
    // make sure Vue does not know about the input
    // this way it can properly unmount
    this.input = document.createElement("input");
    this.$el.querySelector(".geolocation-input").appendChild(this.input);
    // this.$el.appendChild(this.input);
    this.instance = places({
      apiKey: this.apiKey,
      appId: this.appId,
      type: this.type,
      container: this.input,
      language: "de",
      type: "address",
    });
    if (this.prefilled !== null) {
      this.instance.setVal(this.prefilled);
    }
    this.instance.on("change", (e) => {
      console.log(e);

      let geolocation = {
        latlng: e.suggestion.latlng,
        name: e.suggestion.value,
        street: e.suggestion.name,
        zip: e.suggestion.postcode,
        city: e.suggestion.city,
      };
      this.$emit("input", geolocation);
    });
  },
  beforeDestroy() {
    this.instance.off("change");
    this.instance.destroy();
  },
  watch: {
    type(newVal) {
      this.instance.configure({
        type: newVal,
      });
    },
  },
};
</script>

<style>
</style>